import { render, staticRenderFns } from "./DashboardModalPendenciasConversaoCambial.vue?vue&type=template&id=6728172a"
import script from "./DashboardModalPendenciasConversaoCambial.vue?vue&type=script&lang=js"
export * from "./DashboardModalPendenciasConversaoCambial.vue?vue&type=script&lang=js"
import style0 from "./DashboardModalPendenciasConversaoCambial.vue?vue&type=style&index=0&id=6728172a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports